<template>
  <div>
    <span class="remaining-time" :class="messageClass">
      {{ messageText }}
    </span>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import {
  differenceInSeconds,
  differenceInMinutes,
  differenceInHours,
  differenceInDays,
  now
} from "@/utils/date";

@Component
export default class RemainingDateTime extends Vue {
  @Prop({ type: Boolean, required: true }) isHiring!: boolean;
  @Prop({ type: Boolean, default: false }) isApplied!: boolean;
  @Prop({ type: Number }) expiredAt!: number;

  messageText = "";
  messageClass = "";

  private timer = 0;

  beforeMount() {
    this.timer = window.setInterval((): void => {
      this.updateState();
    }, 1000);
    this.updateState();
  }

  beforeUnmount() {
    clearInterval(this.timer);
  }
  remainingTime(d: number): number {
    return this.expiredAt - d;
  }
  remainingDays(d: number): number {
    if (this.remainingTime(d) <= 0) return 0;
    return differenceInDays(this.expiredAt, d);
  }
  remainingHours(d: number): number {
    if (this.remainingTime(d) <= 0) return 0;
    return differenceInHours(this.expiredAt, d) % 24;
  }
  remainingMinutes(d: number): number {
    if (this.remainingTime(d) <= 0) return 0;
    return differenceInMinutes(this.expiredAt, d) % 60;
  }
  remainingSeconds(d: number): number {
    if (this.remainingTime(d) <= 0) return 0;
    return differenceInSeconds(this.expiredAt, d) % 60;
  }
  updateState() {
    if (this.isApplied) {
      this.messageText = "応募済み";
      this.messageClass = "";
      return;
    }

    const nowValue = now();
    if (
      !this.isHiring ||
      this.expiredAt === null ||
      this.expiredAt < nowValue
    ) {
      this.messageText = "募集終了";
      this.messageClass = "";
      return;
    }

    const remainingDays = this.remainingDays(nowValue);
    if (remainingDays > 0) {
      // 24時間以上なら X日前 と表示
      this.messageText = `締切まで${remainingDays}日`;
      this.messageClass = "";
    } else {
      // 24時間切ったら、カウントダウン形式で表示
      const zeroPadding = (num: number): string => {
        return String(num).padStart(2, "0");
      };
      const hh = zeroPadding(this.remainingHours(nowValue));
      const mm = zeroPadding(this.remainingMinutes(nowValue));
      const ss = zeroPadding(this.remainingSeconds(nowValue));
      this.messageText = `締切まで残り${hh}:${mm}:${ss}`;
      this.messageClass = "is-in-24hours";
    }
  }
}
</script>

<style lang="scss" scoped>
.remaining-time {
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: #31383f;
  background-color: #efefef;
  border-radius: 4px;

  &.is-in-24hours {
    color: $red;
    background-color: $background-red;
  }

  &.is-applied {
    color: $dark-blue;
    background-color: $light-blue;
  }
}
</style>
